export const datasSectionKeys = [
    "valorNominal",
    "dataEmissao",
    "dataIntegralizacao",
    "dataVencimento",
    "dataRentabilidadeInicio",
    "dataRentabilidadeFim",
    "frequenciaJuros",
    "frequenciaAmortizacao",
    "dataInicioPagamentoJuros",
    "dataInicioPagamentoAmortizacao",
    "dataCarenciaRecompra",
    "frequenciaRecompra",
]